import { render } from "./PeopleView.vue?vue&type=template&id=41e770da&scoped=true"
import script from "./PeopleView.vue?vue&type=script&lang=js"
export * from "./PeopleView.vue?vue&type=script&lang=js"

import "./PeopleView.vue?vue&type=style&index=0&id=41e770da&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e770da"]])

export default __exports__